import { css } from "@emotion/react";
import { forwardRef } from "react";
import { ChipProps } from "../Chip";
import { useTheme } from "../theme";

export type StatusProps = ChipProps;

export const Status = forwardRef<HTMLSpanElement, StatusProps>(
  ({ color = "default", icon, children, rounded, title, ...props }, ref) => {
    const theme = useTheme();
    return (
      <span
        ref={ref}
        title={title}
        css={[
          theme.typography.body,
          css`
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            padding: 0.75ex 1em;
            color: ${color === "default"
              ? theme.palette.text.primary
              : theme.palette.intentions[color].contrastText};
            cursor: ${title ? "help" : "auto"};
            background-color: ${color === "default"
              ? theme.palette.gray[200]
              : theme.palette.intentions[color]?.main};
            border-radius: ${rounded ? "2ex" : "0.75ex"};
          `,
        ]}
        {...props}
      >
        {icon !== undefined && icon !== null ? (
          <span
            css={css`
              margin-right: 0.5em;
            `}
          >
            {icon}
          </span>
        ) : null}
        {children}
      </span>
    );
  },
);
